module.exports = __webpack_public_path__ + "img/Abnormal_OVERRPM.c6773732.png";